__turbopack_context__.v({
  "category-btn": "Posts-module-scss-module__FCBcRa__category-btn",
  "category-list": "Posts-module-scss-module__FCBcRa__category-list",
  "category-title": "Posts-module-scss-module__FCBcRa__category-title",
  "loading-posts-icon": "Posts-module-scss-module__FCBcRa__loading-posts-icon",
  "loading-posts-icon-container": "Posts-module-scss-module__FCBcRa__loading-posts-icon-container",
});
